// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import dayjs from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs';
import antdPlugin from '/Users/jinzhe/amp-official-site/node_modules/_antd-dayjs-webpack-plugin@1.0.6@antd-dayjs-webpack-plugin/src/antd-plugin.js';

import isSameOrBefore from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/isSameOrBefore';
import isSameOrAfter from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/isSameOrAfter';
import advancedFormat from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/advancedFormat';
import customParseFormat from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/customParseFormat';
import weekday from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/weekday';
import weekYear from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/weekYear';
import weekOfYear from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/weekOfYear';
import isMoment from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/isMoment';
import localeData from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/localeData';
import localizedFormat from '/Users/jinzhe/amp-official-site/node_modules/_dayjs@1.11.23@dayjs/plugin/localizedFormat';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);
dayjs.extend(isMoment);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);

dayjs.extend(antdPlugin);
